export default __webpack_public_path__ + "static/blog1-e90cc93b63309b022efe00d2d7d1a723.png";